import httpClient from './_httpClient';

const END_POINT = '/permissions';

const getPermissionsPerRole = (page = 1, perPage = 10, permission = null) => {
  let params = '?page=' + page + '&per_page='+ perPage;
  if (permission) {
    params += '&permission=' + permission
  }
  return httpClient.get(END_POINT + '-per-role' + params);
};

export {
  getPermissionsPerRole
}
